module.exports = {
  apiHost: "https://api.evergreen.sensoreal.app",
  assetsHost: "https://assets.evergreen.sensoreal.app",
  brandName: "Evergreen",
  header: {
    text: { en: "Your Evergreen Selections" },
    logo: "",
    companyLogo: "",
    color: "#fff",
  },
  langs: [{ code: "en", dir: "ltr" }],
  style: {
    primaryColor: "#435D59",
    textColor: "#fff",
    font: "avenir",
    secondaryFont: "",
    secondaryFontStylesheet: "",
  },
  contact: {
    website:
      "https://www.avjennings.com.au/communities/nsw/evergreen-spring-farm-2570/",
    address: "Corner of Richardson Road and Corder Drive, Spring Farm",
    phone: "131 878",
    email: "",
  },
  links: {
    privacy: "",
    youtube: "https://www.youtube.com/@avjenningsbyavid/featured",
    linkedin: "linkedin.com/company/avid-property-group?originalSubdomain=au",
    twitter: "",
    instagram: "https://www.instagram.com/avid_together/?hl=en",
    facebook:
      "https://www.facebook.com/AVIDPropertyGroupAustralia/?_rdc=2&_rdr#",
  },
  footerLogo:
    "https://static-mbh.sgp1.cdn.digitaloceanspaces.com/avid-edm/general/AVID_White_72dpi.png",
};
